import { atom } from "jotai";

export const navbarPinnedAtom = atom<boolean>(false);
